module.exports = __webpack_public_path__ + "static/media/CONTACTS.f542da3a.jpeg";